import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import {
	InputField,
	SelectField,
	SelectFieldStatus,
	TextAreaField,
} from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { useParams, useSearchParams } from "react-router-dom";
import { LeaseStructureOptions } from "../data";
import { getFormattedDate } from "../../../utils/DateUtils";
import { DurationOptions } from "../../../Constants";
import { Backdrop, Box, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ActivateAsset from "./ActivateAsset";
import { toggleActivateAssetModal } from "../LeaseSlice";

const QuickLeaseAssetForm = ({ leaseData, setLeaseData, updateLeaseObject }) => {
	const dispatch = useDispatch();
	const { activateAssetModal } = useSelector((state) => state.lease);

	console.log(leaseData);
	let { category } = useParams();
	const [searchParams, setSearchParams] = useSearchParams();
	const [formData, setFormData] = useState(leaseData);
	const [action, setAction] = useState("view");
	const [activateAssetTab, setActivateAssetTab] = useState(1);

	const onBeginActivateAsset = () => {
		dispatch(toggleActivateAssetModal(true));
		setActivateAssetTab(1);
	};

	const isEditable = action === "edit";

	useEffect(() => {
		if (searchParams.get("filter") !== "quick_lease") {
			console.log('{ filter: "quick_lease" }');
			setSearchParams({ filter: "quick_lease" });
		}
	}, []);

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(leaseData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// console.log(formData);
		setLeaseData(formData);
		updateLeaseObject(formData);
	};

	useEffect(() => {
		if (activateAssetModal) {
			document.body.style.overflow = "hidden";
		}
		return () => {
			// eslint-disable-next-line no-undef
			document.body.style.overflow = "auto";
		};
	}, [activateAssetModal]);

	return (
		<>
			<Backdrop open={activateAssetModal} sx={{ zIndex: 13 }}>
				<ActivateAsset
					activateAssetTab={activateAssetTab}
					setActivateAssetTab={setActivateAssetTab}
					leaseData={leaseData}
				/>
			</Backdrop>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					leaseData={formData}
					action={action}
					setAction={setAction}
					handleCancel={handleCancel}
					canActivateAsset={category == "inactive" ? true : false}
					handleAssetActivation={onBeginActivateAsset}
				/>

				<div className='RightSection'>
					<FormAccordion title='Lease Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							<div className='form-group'>
								<label>DATE / TIME</label>
								<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
							</div>

							<div className='form-group'>
								<label>TRN ID</label>
								<InputField name='trnId' value={"TRN-" + formData?.objectId} />
							</div>

							<div className='form-group'>
								<label>ASSET NAME</label>
								<InputField name='productName' value={formData?.productName} />
							</div>

							<div className='form-group'>
								<label>CATEGORY</label>
								<InputField name='productCategory' value={formData?.category} />
							</div>

							<div className='form-group'>
								<label>BRAND</label>
								<InputField name='brand' value={formData?.brand} />
							</div>

							<div className='form-group'>
								<label>MODEL</label>
								<InputField name='model' value={formData?.model} />
							</div>

							<div className='form-group'>
								<label>COLOR</label>
								<InputField name='color' value={formData?.color} />
							</div>

							<div className='form-group'>
								<label>INTEREST RATE</label>
								<InputField name='interest' value={formData?.interest} />
							</div>

							<div className='form-group'>
								<label>AMOUNT</label>
								<InputField name='amount' value={formData?.amount} />
							</div>

							<div className='form-group'>
								<label>INVESTMENT TYPE</label>
								<InputField
									name='investmentType'
									handleChange={handleInputChange}
									// isEditable={isEditable}
									value={formData?.type === "full-investment" ? "Full Investment" : ""}
								/>
							</div>

							<div className='form-group'>
								<label>LEASE STRUCTURE</label>
								<SelectField
									name='leaseStructure'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.leaseStructure}
									options={LeaseStructureOptions}
								/>
							</div>

							<div className='form-group'>
								<label>LEASE TYPE</label>
								<SelectField
									name='leaseType'
									handleChange={handleInputChange}
									// isEditable={isEditable}
									value={formData?.leaseType}
									options={["Quick Lease", "Sponsored Lease"]}
								/>
							</div>

							<div className='form-group'>
								<label>LEASE DURATION</label>
								<SelectField
									name='leaseDuration'
									value={formData?.leaseDuration}
									handleChange={handleInputChange}
									isEditable={isEditable}
									options={DurationOptions}
								/>
							</div>

							<div className='form-group'>
								<label>WAITING PERIOD</label>
								<SelectField
									name='waitingPeriod'
									value={formData?.waitingPeriod}
									handleChange={handleInputChange}
									isEditable={isEditable}
									options={DurationOptions}
									required={true}
								/>
							</div>

							<div className='form-group'>
								<label>STATUS</label>
								<SelectFieldStatus
									name='status'
									type={formData?.status?.toLowerCase()}
									value={formData?.status}
								/>
							</div>
						</div>
					</FormAccordion>

					<FormAccordion title='Product description'>
						<div className='form-group'>
							<TextAreaField
								name='product_desc'
								value={formData?.description || formData?.productId.description}
							/>
						</div>
					</FormAccordion>

					<FormAccordion title='Key features'>
						<div className='form-group'>
							<TextAreaField
								name='product_features'
								value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
							/>
						</div>
					</FormAccordion>

					<FormAccordion title='Product specifications'>
						<div className='form-group'>
							<TextAreaField
								name='product_specs'
								value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
							/>
						</div>
					</FormAccordion>

					{leaseData?.status === "active" && (
						<FormAccordion title='Requests on Asset'>
							<Box
								sx={{
									backgroundColor: "#eff8f9",
									padding: "14px",
									border: "1px solid #b8c8cf",
									borderRadius: "5px",
									fontSize: "15px",
								}}>
								{leaseData?.usersRequest?.length > 0 ? (
									<div>
										<Grid container spacing={3} sx={{ fontWeight: 500, maxWidth: "87%" }} marginBottom={1}>
											<Grid item xs={4}>
												Transaction ID
											</Grid>
											<Grid item xs={4}>
												Name of Leasee
											</Grid>
											<Grid item xs={4}>
												Status
											</Grid>
										</Grid>
										{leaseData.usersRequest.map((request) => (
											<RequestsOnAsset key={request.transactionId} request={request} />
										))}
									</div>
								) : (
									<Typography sx={{ fontWeight: 500, fontSize: "inherit" }}>No requests available</Typography>
								)}
							</Box>
						</FormAccordion>
					)}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
QuickLeaseAssetForm.propTypes = {
	leaseData: PropTypes.object,
	setLeaseData: PropTypes.func,
	updateLeaseObject: PropTypes.func,
};

export default QuickLeaseAssetForm;

export const RequestsOnAsset = ({ request }) => {
	return (
		<Grid container spacing={3} sx={{ fontWeight: 400, maxWidth: "87%" }} marginBottom={0.75}>
			<Grid item xs={4}>
				{request?.transactionId}
			</Grid>
			<Grid item xs={4}>
				{request?.name}
			</Grid>
			<Grid item xs={4}>
				{request?.status}
			</Grid>
		</Grid>
	);
};

RequestsOnAsset.propTypes = {
	request: PropTypes.object,
};
